import dayjs from "dayjs";

export function buildMonthKeys(months) {
  const current = dayjs().startOf("month");
  const keys = [];

  for (let i = months - 1; i >= 0; i -= 1) {
    keys.push(current.subtract(i, "month").format("YYYY-MM"));
  }

  return keys;
}

export function buildMonthKeysFromRange(startDate, endDate) {
  const start = dayjs(startDate).startOf("month");
  const end = dayjs(endDate).startOf("month");
  const keys = [];

  let cursor = start;
  while (cursor.isSame(end) || cursor.isBefore(end)) {
    keys.push(cursor.format("YYYY-MM"));
    cursor = cursor.add(1, "month");
  }

  return keys;
}
